import React, { createContext, useState, useEffect } from 'react';

export const PersonaContext = createContext();

export const PersonaProvider = ({ children }) => {
    const getInitialState = (key, defaultValue) => {
        const storedValue = sessionStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : defaultValue;
    };

    const [selectedDataset, setSelectedDataset] = useState(getInitialState('selectedDataset', null));
    const [selectedDatasetName, setSelectedDatasetName] = useState(getInitialState('selectedDatasetName', null));
    const [selectedDatasetPath, setSelectedDatasetPath] = useState(getInitialState('selectedDatasetPath', null));
    const [selectedSectors, setSelectedSectors] = useState(getInitialState('selectedSectors', []));
    const [selectedQuestions, setSelectedQuestions] = useState(getInitialState('selectedQuestions', []));
    const [selectedEthnicities, setSelectedEthnicities] = useState(getInitialState('selectedEthnicities', []));
    const [selectedLocation, setSelectedLocation] = useState(getInitialState('selectedLocation', null));

    useEffect(() => {
        sessionStorage.setItem('selectedDataset', JSON.stringify(selectedDataset));
    }, [selectedDataset]);

    useEffect(() => {
        sessionStorage.setItem('selectedDatasetName', JSON.stringify(selectedDatasetName));
    }, [selectedDatasetName]);

    useEffect(() => {
        sessionStorage.setItem('selectedDatasetPath', JSON.stringify(selectedDatasetPath));
    }, [selectedDatasetPath]);

    useEffect(() => {
        sessionStorage.setItem('selectedSectors', JSON.stringify(selectedSectors));
    }, [selectedSectors]);

    useEffect(() => {
        sessionStorage.setItem('selectedQuestions', JSON.stringify(selectedQuestions));
    }, [selectedQuestions]);

    useEffect(() => {
        sessionStorage.setItem('selectedEthnicities', JSON.stringify(selectedEthnicities));
    }, [selectedEthnicities]);

    useEffect(() => {
        sessionStorage.setItem('selectedLocation', JSON.stringify(selectedLocation));
    }, [selectedLocation]);

    const resetSectors = () => {
        setSelectedSectors([]);
        sessionStorage.removeItem('selectedSectors');
    };

    const resetQuestions = () => {
        setSelectedQuestions([]);
        sessionStorage.removeItem('selectedQuestions');
    };

    const resetState = () => {
        setSelectedDataset(null);
        setSelectedDatasetName(null);
        setSelectedDatasetPath(null);
        setSelectedSectors([]);
        setSelectedQuestions([]);
        setSelectedEthnicities([]);
        setSelectedLocation(null);

        sessionStorage.removeItem('selectedDataset');
        sessionStorage.removeItem('selectedDatasetName');
        sessionStorage.removeItem('selectedDatasetPath');
        sessionStorage.removeItem('selectedSectors');
        sessionStorage.removeItem('selectedQuestions');
        sessionStorage.removeItem('selectedEthnicities');
        sessionStorage.removeItem('selectedLocation');
    };

    return (
        <PersonaContext.Provider
            value={{
                selectedDataset,
                setSelectedDataset,
                selectedDatasetName,
                setSelectedDatasetName,
                selectedDatasetPath,
                setSelectedDatasetPath,
                selectedSectors,
                setSelectedSectors,
                selectedQuestions,
                setSelectedQuestions,
                selectedEthnicities,
                setSelectedEthnicities,
                selectedLocation,
                setSelectedLocation,
                resetState,
                resetQuestions,
                resetSectors
            }}
        >
            {children}
        </PersonaContext.Provider>
    );
};
